import { render, staticRenderFns } from "./CommodityMarketingDisccussReviewEmojiInput.vue?vue&type=template&id=0224ab86&scoped=true&"
import script from "./CommodityMarketingDisccussReviewEmojiInput.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingDisccussReviewEmojiInput.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingDisccussReviewEmojiInput.vue?vue&type=style&index=0&id=0224ab86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224ab86",
  null
  
)

export default component.exports